import './App.css';

import { string } from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';

class App extends Component {

  /////////////
  //EXEMPLO DE CHAMADA: http://localhost:3000/validar?validationCode=2

  // http://localhost:3000/validar?validationCode=8569175F-5016-480B-93AC-F28A452CB53E
  /////////////

  /**PARAMERTROS**/

  //fetch('https://develop.api.mtcidadao.mti.mt.gov.br/v1/saude/dashboardCovid')
  //fetch('http://localhost:8080/v1/saude/dashboardCovid')
  //urlApiValidacao = 'http://jsonplaceholder.typicode.com/users';
  //urlApiValidacao = 'https://develop.api.mtcidadao.mti.mt.gov.br/v1/documentos/cnh/validarCertidaoCondutor';
  urlApiValidacao = 'https://api.mtcidadao.mti.mt.gov.br/v1/documentos/cnh/validarCertidaoCondutor';
  //urlApiValidacao = 'http://localhost:8080/v1/documentos/cnh/validarCertidaoCondutor';
  nomeParametroCodigoValidacao = 'validationCode';

  state = {
    validationCode: '',
    resultadoValidacao: Boolean,
    erroValidar: '',
    resultCertidao: string
  }

  componentDidMount() {
    var url = new URL(window.location.href);
    let codigoUrl = url.searchParams.get(this.nomeParametroCodigoValidacao)

    if(codigoUrl == null) {
      this.setState({ validationCode: 'NÃO RECONHECIDO' })
    }
    
    if(codigoUrl != null) {
      this.validaCodigo();
    }
  }
  
  render () {
    return (
      <div>
        <div class="header-logo-detran"></div>
        <div className="card center">
          {this.telaValidacaoHome}
        </div>
        {this.telaValidacao}
    </div>
    );
  }
 
  validaCodigo() {
    this.setState({ erroValidar: ''});
    var url = new URL(window.location.href);
    let codigoUrl = url.searchParams.get(this.nomeParametroCodigoValidacao);

    if(codigoUrl == null){
      codigoUrl = 'NÃO RECONHECIDO';
      this.setState({ validationCode: codigoUrl })
    }

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 'codigoValidacao' : codigoUrl.toString()})
    };
    
    fetch(this.urlApiValidacao, requestOptions)
    .then(res => res.json())
    .then((data) => {
      console.log('data', data);

      let resultadoValidacao = false;

      if(data?.resultado?.code === 500) {
        resultadoValidacao = false;
        this.setState({ erroValidar: 'Código inválido' })
      } else {
        resultadoValidacao = true;
        this.setState({ erroValidar: 'Sucesso' })
      }

      this.setState({ resultCertidao: data.resultado.Texto });
      this.setState({ validationCode: codigoUrl })
      this.setState({ resultadoValidacao: resultadoValidacao })
    })
    .catch((e)=>{
      this.setState({ erroValidar: 'Serviço indisponível, tente novamente mais tarde' })
      console.log('ERRO AO VALIDAR CODIGO: ' + e);
    });
  }

  validarCodigoDigitado() {
    let codigoDigitado = document.getElementById("codigoCertidao").value;

    if(codigoDigitado !== '') {
      window.location = '/validar?validationCode=' + codigoDigitado;
    }

    if(codigoDigitado === '') {
      alert("Digite um códido para validar!");
    }
  }
  
  get telaValidacaoHome() {
    return (
      <div className="card">
          <div className="card-body">
            <h5 className="card-title">Validação de Certidão de Condutor:</h5>
            <br></br>
            <div id="campoCodigo" className="div-info-codigo center card-subtitle mb-2 text-muted">
                <form>
                    Código de validação: <input type="text" id="codigoCertidao"></input>
                    <br></br>
                    <br></br>
                    <input type="button" onClick={this.validarCodigoDigitado} value="Validar certidão"></input>
                </form>
            </div>
          </div>
      </div>
    )
  }

  get telaValidacao() {
    const dataAtual = moment().format('DD/MM/YYYY hh:mm:ss');
    return (
      <div>
          <div className="card">
              <div className="card-body">
              <h5 className="card-title">Resultado da validação:</h5>
              <br></br>

              {//VALIDACAO OK
              this.state.resultadoValidacao === true && 
              this.state.erroValidar === 'Sucesso' &&
              <div className="div-validacao">
                  <div className="logo-validacao-ok">
                  </div>
                  <div className="texto-validacao-ok">
                      Documento Válido
                  </div>
              </div>
              }

              {//VALIDACAO NOK
              this.state.resultadoValidacao === false && 
              this.state.erroValidar === 'Código inválido' && <div className="div-validacao">
                  <div className="logo-validacao-erro">
                  </div>
                  <div className="texto-validacao-erro">
                  Documento inválido
                  </div>
              </div>
              }
              
              {//ERRO AO CHAMAR API
              this.state.erroValidar === 'Serviço indisponível, tente novamente mais tarde' && <div className="div-validacao">
                  <div className="logo-validacao-indisponivel">
                  </div>
                  <div className="texto-validacao-indisponivel">
                  {this.state.erroValidar}
                  </div>
              </div>
              }

              {//CÓDIGO NÃO RECONHECIDO
              this.state.validationCode === 'NÃO RECONHECIDO' && <div className="div-validacao">
              <div className="logo-validacao-indisponivel">
              </div>
              <div className="texto-validacao-indisponivel">
                  Por favor, forneça um código válido acima!
              </div>
          </div>
          }

              <div className="div-info-codigo left card-subtitle mb-2 text-muted">
                  <div className="">
                      <div className="left">Código de validação:&nbsp;</div>
                      <div className="bold">{this.state.validationCode}</div>
                  </div>
                  <div>Verificado em : {dataAtual}</div>
              </div>
              </div>
          </div>

          {
          this.state.resultadoValidacao === true &&
          <div> 
              <div className="card-body">
                  <h5 className="card-title">Certidão de Condutor:</h5>
                  <div dangerouslySetInnerHTML={{ __html: this.state.resultCertidao }}>
                  </div>
              </div>

              <div className="card-body center">
                  <button onClick={window.print}>Imprimir</button>
              </div>
          </div>
          }  
      </div>
    )
  }
}

export default App;